export default __webpack_public_path__ + "static/media/car.562e6e3a.png";